"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regionViewerScale = exports.mergeOverlappingRegions = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var mergeOverlappingRegions = function mergeOverlappingRegions(regions) {
  if (regions.length === 0) {
    return [];
  }

  var mergedRegions = [_objectSpread({}, regions[0])];
  var previousRegion = mergedRegions[0];

  for (var i = 1; i < regions.length; i += 1) {
    var nextRegion = regions[i];

    if (nextRegion.start <= previousRegion.stop + 1) {
      if (nextRegion.stop > previousRegion.stop) {
        previousRegion.stop = nextRegion.stop;
      }
    } else {
      previousRegion = _objectSpread({}, nextRegion);
      mergedRegions.push(previousRegion);
    }
  }

  return mergedRegions;
};

exports.mergeOverlappingRegions = mergeOverlappingRegions;

var regionViewerScale = function regionViewerScale(domainRegions, range) {
  var totalRegionSize = domainRegions.reduce(function (acc, region) {
    return acc + (region.stop - region.start + 1);
  }, 0);

  var scale = function scale(position) {
    var distanceToPosition = domainRegions.filter(function (region) {
      return region.start <= position;
    }).reduce(function (acc, region) {
      return region.start <= position && position <= region.stop ? acc + position - region.start : acc + (region.stop - region.start + 1);
    }, 0);
    return range[0] + (range[1] - range[0]) * (distanceToPosition / totalRegionSize);
  };

  scale.invert = function (x) {
    var clampedX = Math.max(Math.min(x, range[1]), range[0]);
    var distanceToPosition = Math.floor(totalRegionSize * ((clampedX - range[0]) / (range[1] - range[0])));

    for (var i = 0; i < domainRegions.length; i += 1) {
      var region = domainRegions[i];
      var regionSize = region.stop - region.start + 1;

      if (distanceToPosition < regionSize) {
        return region.start + distanceToPosition;
      }

      distanceToPosition -= regionSize;
    }

    return domainRegions[domainRegions.length - 1].stop;
  };

  return scale;
};

exports.regionViewerScale = regionViewerScale;